import { InputHTMLAttributes } from 'react';

import { CheckBox as OrionCheckBox } from '@iwoca/orion';
import { clsx } from 'clsx';
import { useField } from 'formik';
import { useFormContext, useWatch } from 'react-hook-form';

import { InputError } from '../../../components/InputError/InputError';
import { extractError } from '../../../utils/ReactHookForm';

export const Checkbox = ({
  labelText,
  name,
  disabled,
  className,
  wrapperClassName,
}: {
  name: string;
  labelText: React.ReactNode;
  disabled?: boolean;
  className?: string;
  wrapperClassName?: string;
} & InputHTMLAttributes<HTMLInputElement>) => {
  const [field, { error, touched, value }] = useField(name);

  return (
    <div>
      <div
        className={clsx(className, 'flex', {
          '[&>input]:!border-structure-60 [&>input]:!bg-structure-60': disabled,
        })}
      >
        <OrionCheckBox
          {...field}
          name={name}
          id={name}
          checked={value}
          disabled={disabled}
          wrapperClassName={wrapperClassName}
          // @ts-expect-error
          label={labelText}
        />
      </div>
      <InputError isVisible={touched} error={error} />
    </div>
  );
};

/** @public — temporarily unused; consumers migrating from formik will adopt this in follow-up MRs (IP-3162) */
export const HookFormCheckbox = ({
  labelText,
  name,
  disabled,
  className,
  wrapperClassName,
}: {
  name: string;
  labelText: React.ReactNode;
  disabled?: boolean;
  className?: string;
  wrapperClassName?: string;
} & InputHTMLAttributes<HTMLInputElement>) => {
  const { register, control, formState } = useFormContext();
  const value = useWatch({ control, name });
  const error = extractError(formState.errors[name]);

  return (
    <div>
      <div
        className={clsx(className, 'flex', {
          '[&>input]:!border-structure-60 [&>input]:!bg-structure-60': disabled,
        })}
      >
        <OrionCheckBox
          {...register(name)}
          id={name}
          checked={Boolean(value)}
          disabled={disabled}
          wrapperClassName={wrapperClassName}
          // @ts-expect-error
          label={labelText}
        />
      </div>
      <InputError isVisible={formState.isSubmitted} error={error} />
    </div>
  );
};
